import React from 'react';
import {ButtonsGroup} from 'components/common/ButtonsGroup';
import {history} from 'core/services/history';
import {connectWithIntl} from 'core/services/connectWithIntl';

export class BrokerManagerDetailsActionsComponent extends React.Component {
    render() {
        return (
            <ButtonsGroup onCancel={() => history.goToBrokerManagers()} />
        );
    }
}


export const BrokerManagerDetailsActions = connectWithIntl()(
    BrokerManagerDetailsActionsComponent,
);
